import styled from 'styled-components/native'
import SearchField from 'APP/Components/SearchField'
import { Animated, View, ScrollView } from 'react-native'

import { isWeb } from 'APP/Helpers/checkPlatform'

export const ContentContainer = styled(Animated.View)`
  flex: 1;
  overflow: hidden;
  flex-wrap: nowrap;
  justify-content: flex-start;
  margin-vertical: ${({ theme }) =>
    isWeb() ? theme.metrics.baseMargin * 2 : theme.metrics.baseMargin}px;
  margin-horizontal: ${({ theme }) => theme.metrics.baseMargin}px;
  border-radius: ${({ theme }) => (isWeb() ? theme.metrics.borderRadius.medium : 0)}px;
  background-color: ${({ theme }) => (isWeb() ? theme.colors.elementsBg : 'none')};
  ${({ theme }) => (isWeb() ? theme.shadows.normal : 'none')}
`

export const SearchContainer = styled(View)`
  background-color: ${({ theme }) => (isWeb() ? theme.colors.elementsBg : 'none')};
  padding-top: ${({ theme }) => (isWeb() ? theme.metrics.baseMargin : 0)}px;
`

export const StyledSearchField = styled(SearchField)`
  padding: ${({ theme }) => theme.metrics.baseMargin}px;
  padding-top: 0;
`

export const ButtonContainer = styled(View)`
  display: flex;
  flex-direction: row;
  justify-content: end;
  gap: ${({ theme }) => theme.metrics.baseMargin}px;
  padding: ${({ theme }) => `${theme.metrics.baseMargin}px`};
  align-items: flex-end;
  flex-wrap: wrap;
`

export const StyledScrollView = styled(ScrollView)`
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin}px;
`
